import logo from './logo.svg';
import './App.css';
import { Route, BrowserRouter, Routes } from "react-router-dom";

// import {Groups} from './page';
import {Home} from "./page";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/*<Route path={"/"} element={<Groups/>}/>*/}
        <Route path={"/"} element={<Home/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
